import { Link, useLocation  } from 'react-router-dom';
import './Navbar.css'
import { useState } from 'react';

function NavBar()
{
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
      setIsOpen(!isOpen);
    };
    return(
        
        <div className='nav'>
               <Link className='Logo' to={'/'}><img src='https://i.imgur.com/3YukZCn.png'/></Link>
<nav className={`menu-container ${isOpen ? 'open' : ''}`}>
  <div className="menu">
    <Link to="/" onClick={() => setIsOpen(false)} className={`home${location.pathname === '/' ? ' active' : ''}`}>Home</Link>
    <Link to="/about" onClick={() => setIsOpen(false)} className={`about${location.pathname === '/about' ? ' active' : ''}`}>About</Link>
    <Link to="/project" onClick={() => setIsOpen(false)} className={`project${location.pathname === '/project' ? ' active' : ''}`}>Project</Link>
    <Link to="/contact" onClick={() => setIsOpen(false)} className={`contact${location.pathname === '/contact' ? ' active' : ''}`}>Contact</Link>
  </div>
</nav>
            <div className="burger-menu">
      <div className={`burger-icon ${isOpen ? 'open' : ''}`} onClick={toggleMenu}>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>
      </div>
        </div>
    );
};
export default NavBar;